import { NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular/lazy';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StoreModule } from '@ngrx/store';
import { effects, reducers } from './lib/b2b-stores';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { STORAGE_CONSTANT } from '@app/lib/b2b-constants/storage.constant';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';
import { NoopHttpInterceptorService } from '@app/lib/b2b-services/interceptors/noop-http-interceptor.service';
import { B2bNavigationModule } from '@app/lib/b2b-components/b2b-navigation/b2b-navigation.module';
import { SharedModule } from '@app/lib/shared/shared.module';
import { HttpLoaderInterceptorService } from '@app/lib/b2b-services/interceptors/loader-interceptor.service';
import { B2bLoadersModule } from '@app/lib/b2b-components/b2b-loaders/b2b-loaders.module';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { initializeApp } from '@app/lib/b2b-initializer/app-provider';
import { LMDB_HTTP_GET, LMDB_HTTP_POST } from '@b2b/lmdb-cache-lib';
import type { LmdbPostRequestBody } from '@b2b/lmdb-cache-lib';
import { HttpClientService } from '@app/lib/b2b-services/util/http-client.service';

export const jwtOptionsFactory = (storage) => ({
  tokenGetter: () => storage.get(STORAGE_CONSTANT.AUTH_TOKEN),
  // allowedDomains: ['example.com']
});

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    // AngularFireAuthModule,
    // IonicStorageModule.forRoot(),
    IonicStorageModule.forRoot({
      name: 'b2bStorageDb',
      // driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage],
      },
    }),
    AppRoutingModule,
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true,
    }),
    EffectsModule.forRoot(effects),
    B2bNavigationModule,
    // TODO: Need to remove SharedModule in future
    SharedModule,
    B2bLoadersModule,
    FormsModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoopHttpInterceptorService,
      multi: true,
    },
    provideAppInitializer(initializeApp),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {
      provide: LMDB_HTTP_GET,
      useFactory:
        (http: HttpClientService) => (path: string, baseUrl: string) =>
          http.get(path, {}, false, baseUrl),
      deps: [HttpClientService],
    },
    {
      provide: LMDB_HTTP_POST,
      useFactory:
        (http: HttpClientService) =>
          (path: string, baseUrl: string, body: LmdbPostRequestBody) =>
            http.post(path, body, {}, false, baseUrl),
      deps: [HttpClientService],
    },
  ],
})
export class AppModule {}
